import React from 'react';
import ResumeBuilder from '../ResumeBuilder/ResumeBuilder';

const AdminResumeBuilder = ({ resumeToEdit, onSave, onBackToList }) => {
  return (
    <div className="admin-resume-builder">
      <ResumeBuilder 
        resumeToEdit={resumeToEdit}
        onSave={onSave}
        onBackToList={onBackToList}
        headerTitle={resumeToEdit ? 'Edit Resume' : 'Create New Resume'}
      />
    </div>
  );
};

export default AdminResumeBuilder; 